import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 56,
	viewBox: "0 0 57 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.83301 37.3333L10.9997 14H45.9997L54.1663 37.3333L28.4997 49L2.83301 37.3333Z",
		fill: "#896ADE"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M55.2865 37.0093L47.1198 13.6759C46.974 13.1778 46.5178 12.8359 45.9998 12.8359H10.9998C10.4818 12.8359 10.0257 13.1778 9.87984 13.6759L1.71317 37.0093C1.67 37.1469 1.6665 37.2368 1.6665 37.3359V53.6693C1.6665 54.3133 2.18917 54.8359 2.83317 54.8359H54.1665C54.8105 54.8359 55.3332 54.3133 55.3332 53.6693V37.3359C55.3332 37.2368 55.3297 37.1469 55.2865 37.0093ZM36.6665 36.1693V42.0026C36.6665 42.6466 36.1438 43.1693 35.4998 43.1693H21.4998C20.8558 43.1693 20.3332 42.6466 20.3332 42.0026V36.1693H4.38834L11.8748 15.1693H45.1248L52.6113 36.1693H36.6665Z",
		fill: "#CCBFF3"
	})]
});
export default SvgArchive;
